import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { callRequestAccountDeletion } from "../lib/firebase";
import { ProfileForm } from "../components/ProfileForm";

export function ProfilePage() {
  const { user, signOut, profile, refreshProfile } = useAuth();
  const [savedAt, setSavedAt] = useState<number | null>(null);
  const [confirming, setConfirming] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!user) return null;

  async function deleteAccount() {
    setError(null);
    try {
      await callRequestAccountDeletion();
      await signOut();
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    }
  }

  return (
    <main className="profile-page">
      <header className="page-header">
        <Link to="/dashboard" className="page-header__back">← Dashboard</Link>
      </header>

      <span className="kicker">บัญชีของฉัน</span>
      <h1 style={{ marginBottom: "0.5rem" }}>โปรไฟล์</h1>
      <p style={{ color: "var(--c-text-muted)", marginBottom: "2.5rem" }}>
        อีเมล: <strong style={{ color: "var(--c-text)" }}>{user.email}</strong>
      </p>

      {profile && (
        <ProfileForm
          key={savedAt ?? 0}
          userId={user.uid}
          initial={profile}
          submitLabel="บันทึกโปรไฟล์"
          onSaved={async () => {
            await refreshProfile();
            setSavedAt(Date.now());
          }}
        />
      )}
      {savedAt && <p style={{ color: "var(--c-green)", marginTop: "0.75rem" }}>✓ บันทึกแล้ว</p>}

      <section className="danger-zone">
        <h2>ลบบัญชี</h2>
        <p>ลบบัญชีถาวรพร้อมข้อมูลทั้งหมด การกระทำนี้ย้อนกลับไม่ได้</p>
        {!confirming ? (
          <button className="btn-danger" onClick={() => setConfirming(true)}>ขอลบบัญชี</button>
        ) : (
          <div className="form-actions">
            <button className="btn-danger" onClick={deleteAccount}>ยืนยันลบ</button>
            <button className="btn-secondary" onClick={() => setConfirming(false)}>ยกเลิก</button>
          </div>
        )}
      </section>

      {error && <p className="error" style={{ marginTop: "1.5rem" }}>{error}</p>}
    </main>
  );
}
